import React, {
	forwardRef,
	useEffect,
	useImperativeHandle,
	useState,
} from "react";
import axios from "axios";
import Loader from "../../../shared/loader/loader";
import Tooltip from "../../../shared/toolTip";
import { useBlocker } from "react-router";
import { showNotification } from "../../../shared/showNotification";

//         tooltipData = [<>This should be the name of your Album as originally released.</>, <>This is the name of th Record Label under which this Album is or was published. This may or may not necessarily reflect the current Label the Artist is under.</>, <>This should reflect the actual Genre of this Dalbum. It may or may not reflect the Genre stated on your Artist Profile.</>, <>This is the year that your album was originally released in any form. If this is its first publication, then you should insert the current year.</>, <>This is the Copyright Number associated with the material on this Dalbum, if you have copyrighted it.  It is not mandatory, but it is useful in the event that anyone disputes your rights to the material. To find out more about copyrighting your work in the U.S., please visit: https://www.copyright.gov/</>, <>This is the name under which the copyright to the work on this Dalbum is registered.</>, <>We recommend you have a unique UPC Barcode for your Dalbum - even if you already have one for your physical album. This way, sales can be tracked independently. We recommend you check online to see where you can get one. If your songs are already online, each track should have its own ISRC number, as well. We like this website: <a href="">http://www.nationwidebarcode.com/purchase-barcodes/barcodes-for-music/</a></>, <>According to RIAA website: It is obviously not possible to define each individual situation in which a record label or artist should determine that a sound recording contains PAL Content. In making such a determination, however, record labels and artists should consider:<br /> 1. That contemporary cultural morals and standards should be used in determining whether parents or guardians would find the sound recording suitable for children;<br /> 2. The context in which the material is used, as some words, phrases, sounds, or descriptions might be offensive to parents if spotlighted or emphasized, but might not offend if merely part of the background or a minimal part of the lyrics;<br /> 3. The context of the artist performing the material, as well as the expectations of the artist�s audience;<br /> 4. That lyrics are often susceptible to varying interpretations, and that words can have different meanings and should not be viewed in isolation from the music that accompanies them (i.e., lyrics when accompanied by loud and raucous music can be perceived differently than the same lyrics when accompanied by soft and soothing music);<br /> 5. That such a determination requires sensitivity and common sense, and that context, frequency, and emphasis are obviously important; isolated or unintelligible references to certain material might be insufficient to warrant labeling a particular sound recording as containing PAL Content;<br /> 6. That these Standards apply to the case of a single track commercially released as well as to full albums (whether released in the form of a CD, cassette or any other configuration); and <br /> 7. That a sound recording may contain strong language or depictions of violence, sex, or substance abuse, yet due to other factors involved, may not merit a designation as containing PAL Content.<br /> The record label or artist determination that a sound recording contains PAL Content shall affect the marketing, sale, and distribution of such sound recording, as described in greater detail throughout these Standards. For purposes of clarification, only the applicable record label or artist shall determine whether any particular sound recording contains PAL Content, and all other Participants shall abide by the applicable record label or artist�s determination.  <br /> If your Dalbum includes Explicit Material, DalbumX will include an �E� symbol by your Dalbum�s description to make buyers aware on the Dalbum Xchange Page. <br />For more information <a href="https://riaa.com/toolsforparents.php?content_selector=parental_advisory">click here</a></>]
//  Lalo: 03/01/2021 -         tooltipData = [<>This should be the name of your Dalbum as originally released.</>, <>If there is no Record Label for this Dalbum, please write 'Independent' in this field.</>, <>This should reflect the actual Genre of this Dalbum. It may or may not reflect the Genre stated on your Artist Profile.</>, <>This is the year that your Dalbum was originally released in any form. If this is its first publication, then you should insert the current year.</>, <>This is the Copyright Number associated with the material on this Dalbum, if you have copyrighted it.  It is not mandatory, but it is useful in the event that anyone disputes your rights to the material. To find out more about copyrighting your work in the U.S., please visit: <a href="">https://www.copyright.gov/</a></>, <>This is the name under which the copyright to the work on this Dalbum is registered.</>, <>According to RIAA website: It is obviously not possible to define each individual situation in which a record label or artist should determine that a sound recording contains PAL Content. In making such a determination, however, record labels and artists should consider:<br /> 1. That contemporary cultural morals and standards should be used in determining whether parents or guardians would find the sound recording suitable for children;<br /> 2. The context in which the material is used, as some words, phrases, sounds, or descriptions might be offensive to parents if spotlighted or emphasized, but might not offend if merely part of the background or a minimal part of the lyrics;<br /> 3. The context of the artist performing the material, as well as the expectations of the artist�s audience;<br /> 4. That lyrics are often susceptible to varying interpretations, and that words can have different meanings and should not be viewed in isolation from the music that accompanies them (i.e., lyrics when accompanied by loud and raucous music can be perceived differently than the same lyrics when accompanied by soft and soothing music);<br /> 5. That such a determination requires sensitivity and common sense, and that context, frequency, and emphasis are obviously important; isolated or unintelligible references to certain material might be insufficient to warrant labeling a particular sound recording as containing PAL Content;<br /> 6. That these Standards apply to the case of a single track commercially released as well as to full Dalbums (whether released in the form of a CD, cassette or any other configuration); and <br /> 7. That a sound recording may contain strong language or depictions of violence, sex, or substance abuse, yet due to other factors involved, may not merit a designation as containing PAL Content.<br /> The record label or artist determination that a sound recording contains PAL Content shall affect the marketing, sale, and distribution of such sound recording, as described in greater detail throughout these Standards. For purposes of clarification, only the applicable record label or artist shall determine whether any particular sound recording contains PAL Content, and all other Participants shall abide by the applicable record label or artist�s determination.  <br /> If your Dalbum includes Explicit Material, DalbumX will include an �E� symbol by your Dalbum�s description to make buyers aware on the Dalbum Xchange Page. <br />For more information <a href="https://riaa.com/toolsforparents.php?content_selector=parental_advisory">click here</a></>]

const Step2AddAlbumComponent = forwardRef(({ changestep, updateSize, confirmation }, ref) => {
	const [state, setState] = useState({
		genre: [],
		subGenre: [],
		stepdata: {},
		loader: false,
		error: {},
		maxChar: 250,
	});

	const tooltipData = [
		<>This should be the name of your Dalbum as originally released.</>,
		<>
			If there is no Record Label for this Dalbum, please write 'unsigned' in
			this field.
		</>,
		<>
			This should reflect the actual Genre of this Dalbum. It may or may not
			reflect the Genre stated on your Artist Profile.
		</>,
		<>
			Identifying a sub-genre may make it easier for fans who love your specific
			type of music to find your Dalbum in the DalbumXchange. If you would
			rather not identify a sub-genre, select or leave it as "none" and it will
			appear in the DalbumXchange under the primary genre selected.
		</>,
		<>
			This is the year that your Dalbum was originally released in any form. If
			this is its first publication, then you should insert the current year.
		</>,
		<>
			This is the Copyright Number associated with the material on this Dalbum,
			if you have copyrighted it. It is not mandatory, but it is useful in the
			event that anyone disputes your rights to the material. To find out more
			about copyrighting your work in the U.S., please visit:{" "}
			<a href="https://www.copyright.gov/" target="_blank">
				https://www.copyright.gov/
			</a>
		</>,
		<>
			This is the name under which the copyright to the work on this Dalbum is
			registered.
		</>,
		<>
			According to RIAA website: It is obviously not possible to define each
			individual situation in which a record label or artist should determine
			that a sound recording contains PAL Content. In making such a
			determination, however, record labels and artists should consider:
			<br /> 1. That contemporary cultural morals and standards should be used
			in determining whether parents or guardians would find the sound recording
			suitable for children;
			<br /> 2. The context in which the material is used, as some words,
			phrases, sounds, or descriptions might be offensive to parents if
			spotlighted or emphasized, but might not offend if merely part of the
			background or a minimal part of the lyrics;
			<br /> 3. The context of the artist performing the material, as well as
			the expectations of the artist's audience;
			<br /> 4. That lyrics are often susceptible to varying interpretations,
			and that words can have different meanings and should not be viewed in
			isolation from the music that accompanies them (i.e., lyrics when
			accompanied by loud and raucous music can be perceived differently than
			the same lyrics when accompanied by soft and soothing music);
			<br /> 5. That such a determination requires sensitivity and common sense,
			and that context, frequency, and emphasis are obviously important;
			isolated or unintelligible references to certain material might be
			insufficient to warrant labeling a particular sound recording as
			containing PAL Content;
			<br /> 6. That these Standards apply to the case of a single track
			commercially released as well as to full Dalbums (whether released in the
			form of a CD, cassette or any other configuration); and <br /> 7. That a
			sound recording may contain strong language or depictions of violence,
			sex, or substance abuse, yet due to other factors involved, may not merit
			a designation as containing PAL Content.
			<br /> The record label or artist determination that a sound recording
			contains PAL Content shall affect the marketing, sale, and distribution of
			such sound recording, as described in greater detail throughout these
			Standards. For purposes of clarification, only the applicable record label
			or artist shall determine whether any particular sound recording contains
			PAL Content, and all other Participants shall abide by the applicable
			record label or artist's determination. <br /> If your Dalbum includes
			Explicit Material, DalbumX will include an 'E' symbol by your Dalbum's
			description to make buyers aware on the Dalbum Xchange Page. <br />
			For more information{" "}
			<a href="https://riaa.com/toolsforparents.php?content_selector=parental_advisory">
				click here
			</a>
		</>,
	];

	const newLocal = `Describe your Dalbum here in 250 characters or less. This is your "elevator pitch". What's it about? What sounds does it have? Make it catchy! This will appear on your public DalbumX Dalbum page. And remember to check for typos! This cannot be changed after your Dalbum is published.`;
	const descripPlace = newLocal;

	useEffect(() => {
		window.$('[data-toggle="tooltip"]').tooltip();
		getGenre();
		getSubGenre();
		if (sessionStorage.getItem("album_id") !== null) {
			getData();
		}
	}, []);

	useImperativeHandle(ref, () => ({
		save: save,
	}));

	const [stateChanged, setStateChanged] = useState(false);

	useBlocker(() => { 
		if (stateChanged) {
			confirmation(save);
			setStateChanged(false);
		}
	});

	const save = async () => {
		await validate();
	};

	const validate = async () => {
		errorValidation("temp", true);
		if (Object.keys(state.error).length > 0) {
			return false;
		}
		await updateAlbum();
		return true;
	};

	const next = async () => {
		let flag = await validate();
		if (flag) {
			changestep(3);
		}
	};

	const back = () => {
		save();
		changestep(1);
	};

	const updateAlbum = async () => {
		setState((oldState) => ({
			...oldState,
			loader: true,
		}));
		var config = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("tokenArtist"),
			},
		};

		await axios
			.post("app/addalbum/step2", state.stepdata, config)
			.then(function (response) {
				if (response.data.success) {
					showNotification("Dalbum Updated", "success");
					updateSize();
					setState((oldState) => ({
						...oldState,
						loader: false,
					}));
					return true;
					// changestep(3)
				} else {
					showNotification("Server Error" + response.data.message, "error");
					return false;
				}
			})
			.then(async () => { 
				// TODO : updating album price to 1 explicitly since manage price section is blocked.
				await updateAlbumPrice();
			})
			.catch(function (error) {
				showNotification(error.name, "warning");
				return false;
			});
	};

	const updateAlbumPrice = async () => {
		let config = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("tokenArtist"),
			},
		};

		let albumPriceData = {
			price: 1.0,
			album_id: sessionStorage.getItem("album_id"),
		};
		axios
			.post("app/addalbum/updateprice", albumPriceData, config)
			.then(function (response) {
				if (response.data.success) {
					setState((oldState) => ({
						...oldState,
						loader: false,
					}));
				}
			})
			.catch(function (error) {
				showNotification(error.name, "warning");
			});
	};

	const getData = () => {
		setState((oldState) => ({
			...oldState,
			loader: true,
		}));
		var config = {
			headers: {
				Authorization: "Bearer " + localStorage.getItem("tokenArtist"),
			},
		};

		axios
			.get(
				"app/addalbum/step2?album_id=" + sessionStorage.getItem("album_id"),
				config
			)
			.then(function (response) {
				if (response.data.success) {
					// Lalo: 03/12/2021 - Force an "unsigned" value fpr the dalbum label
					if (response.data.data["dalbum_record_lbl"] === null) {
						response.data.data["dalbum_record_lbl"] = "";
					}

					setState((oldState) => ({
						...oldState,
						stepdata: response.data.data,
						loader: false,
					}));
					showNotification("Data Loaded", "success");
				} else {
					showNotification("Server Error" + response.data.message, "error");
				}
			})
			.catch(function (error) {
				showNotification(error.name, "warning");
			});
	};

	const containExplicit = (event) => {
		var data = state.stepdata;
		if (event.target.value || parseInt(event.target.value) == 0) {
			let temp = state.error;
			delete temp.contain_explicit_material;
			setState((oldState) => ({
				...oldState,
				error: temp,
			}));
		}
		data.contain_explicit_material = parseInt(event.target.value);
		setState((oldState) => ({
			...oldState,
			stepdata: data,
		}));
	};

	const getGenre = () => {
		axios
			.get("/genre?page=" + 1 + "&limit=" + 1200)
			.then(function (response) {
				if (response.data.data.result) {
					setState((oldState) => ({
						...oldState,
						genre: response.data.data.result,
					}));
				}
			})
			.catch(function (error) {
				showNotification("Network Connection Error", "error");
			});
	};
	const getSubGenre = () => {
		axios
			.get("/sub_genre?page=" + 1 + "&limit=" + 1200)
			.then(function (response) {
				if (response.data.data.result) {
					showNotification("All Entries Loded", "success");
					setState((oldState) => ({
						...oldState,
						subGenre: response.data.data.result,
					}));
				}
			})
			.catch(function (error) {
			});
	};
	const errorValidation = (name, flag) => {
		{
			/* Lalo - 11/20/2020 - Took out subGenre from the required list.
        let required = { contain_explicit_material: 'This', name: 'Name', dalbum_record_lbl: 'Record Label', genre_id: 'Genre', sub_genre_id: 'Sub Genre', copyright_year: "Year must be between 1901 and " + new Date().getFullYear() }
*/
		}
		let required = {
			contain_explicit_material: "This",
			name: "Name",
			dalbum_record_lbl: "Record Label",
			genre_id: "Genre",
			copyright_year:
				"Year must be between 1901 and " + new Date().getFullYear(),
		};
		var err = state.error;
		if (flag) {
			for (var elem in required) {
				errorValidation(elem);
			}
			return;
		}

		if (required[name]) {
			if (name === "copyright_year") {
				let temp = parseInt(state.stepdata[name]);
				if (
					temp < 1901 ||
					temp > new Date().getFullYear() ||
					state.stepdata[name] == null ||
					state.stepdata[name] === ""
				) {
					err[name] = required[name];
				} else {
					delete err[name];
				}
			} else if (name === "contain_explicit_material") {
				if (state.stepdata[name] !== 1 && state.stepdata[name] !== 0) {
					err[name] = required[name] + " is required";
				}
			} else if (String(state.stepdata[name]) === "" || !state.stepdata[name]) {
				err[name] = required[name] + " is required";
			} else {
				delete err[name];
			}
		}

		setState((oldState) => ({
			...oldState,
			error: err,
		}));
	};

	const handleInputChange = (event) => {
		const target = event.target;
		const name = target.name;
		var value = target.value;

		if (name === "dalbum_desc") {
			value = value.length <= state.maxChar ? value : value.substring(0, 250);
			setState((oldState) => ({
				...oldState,
				// description: e.target.value.length <= state.maxChar ? e.target.value : e.target.value.substring(0, 250),
				chars: value.length <= state.maxChar ? value.length : 250,
			}));
		}
		// -------------------------------------------
		// Lalo: 03/11/2021 - Add new code to handle
		// dalbum_lbl
		// -------------------------------------------
		if (name === "dalbum_record_lbl") {
			if (value.length === 0) {
				// value = "unsigned";
				var data = state.stepdata;
				data[name] = value;
				setState((oldState) => ({
					...oldState,
					stepdata: data,
				}));
			}
		}

		if (name === "copyright_year") {
			const re = /^[0-9\b]+$/;
			if (re.test(value)) {
				value = value.slice(0, 4);
			} else {
				value = "";
			}
		}

		var data = state.stepdata;
		data[name] = value;
		setState((oldState) => ({
			...oldState,
			stepdata: data,
		}));
		if (name !== "copyright_year") {
			errorValidation(name);
		}

		setStateChanged(true);
	};

	const handleSubmit = (event) => {};

	// ----------------------------------------------------
	// Lalo: 03/15/2021 - Try to prevent the text in the
	//                    descripPlace from showing all
	//                    lowercase
	// ----------------------------------------------------
	const Capitalize = (str) => {
		return str.charAt(0).toUpperCase() + str.slice(1);
	};

	

	return (
		<div>
			{state.loader && <Loader />}
			<div className="row mb30">
				<div className="col-md-12">
					<h5 className="require-field mb30">
						[<span className="red">*</span>] Indicates required field
					</h5>
				</div>
			</div>

			<div className="row mb30 custom-tool">
				<div className="col-md-8 offset-md-1">
					<div className="form-group row align-items-center step-2">
						<div className="col-sm-4">
							<p className="text-right mobile-text-left">
								<label className="col-form-label text-uppercase" htmlFor="name">
									<span className="red">*</span>Name of Dalbum:
								</label>
							</p>
						</div>
						<div className="col-md-6 col-lg-4 col-10">
							<input
								type="text"
								value={state.stepdata?.name ?? ""}
								onChange={handleInputChange}
								name="name"
								className="form-control"
								id=""
								placeholder=""
							/>
							{state.error.name && (
								<span id="error" className="error-text">
									{state.error.name}{" "}
								</span>
							)}
						</div>
						<div className="col-md-2 col-2 lpadding mobileTooltip">
							<Tooltip message={tooltipData[0]} color="#a9adac" />
						</div>
					</div>
					<div className="form-group row">
						<label
							className="col-sm-4 col-form-label text-right text-uppercase mobile-text-left"
							htmlFor="name"
						>
							Description:
						</label>
						<div className="col-md-6 col-lg-8 col-10">
							<textarea
								value={state.stepdata.dalbum_desc}
								placeholder={Capitalize(descripPlace)}
								onChange={handleInputChange}
								name="dalbum_desc"
								className="form-control col-md-12 cusText"
								rows="4"
							></textarea>
							<span>
								Characters Left:{" "}
								{state.maxChar - (state.chars ? state.chars : 0)}/
								{state.maxChar}
							</span>
						</div>
					</div>
					<div className="form-group row align-items-center step-2">
						<div className="col-sm-4">
							<p className="text-right mobile-text-left">
								<label className="col-form-label text-uppercase" htmlFor="name">
									<span className="red">*</span>Record Label:
								</label>
							</p>
						</div>
						<div className="col-md-6 col-lg-4 col-10">
							<input
								type="text"
								value={
									state.stepdata.dalbum_record_lbl ? state.stepdata.dalbum_record_lbl : ""
									// state.stepdata.dalbum_record_lbl
								}
								onChange={handleInputChange}
								name="dalbum_record_lbl"
								className="form-control"
								id=""
								placeholder="unsigned"
							/>
							{state.error.dalbum_record_lbl && (
								<span id="error" className="error-text">
									{state.error.dalbum_record_lbl}{" "}
								</span>
							)}
						</div>
						<div className="col-md-2 col-2 lpadding mobileTooltip">
							<Tooltip message={tooltipData[1]} color="#a9adac" />
						</div>
					</div>
					<div className="form-group row align-items-center step-2">
						<div className="col-sm-4">
							<p className="text-right mobile-text-left">
								<label className="col-form-label text-uppercase" htmlFor="name">
									<span className="red">*</span>Genre:
								</label>
							</p>
						</div>
						<div className="col-md-6 col-lg-4 col-10">
							<select
								value={
									state.stepdata.genre_id
										? state.stepdata.genre_id
										: "notSelected"
								}
								className="form-control"
								name="genre_id"
								onChange={handleInputChange}
							>
								<option disabled value="notSelected">
									Select One
								</option>
								{state.genre.map((genre, index) => (
									<option key={index} value={genre.genre_id}>
										{genre.name}
									</option>
								))}
							</select>
							{state.error.genre_id && (
								<span id="error" className="error-text">
									{state.error.genre_id}{" "}
								</span>
							)}
						</div>
						<div className="col-md-2 col-2 lpadding mobileTooltip">
							<Tooltip message={tooltipData[2]} color="#a9adac" />
						</div>
					</div>
					<div className="form-group row align-items-center step-2">
						<div className="col-sm-4">
							<p className="text-right mobile-text-left">
								{/* Lalo - 11/20/2020 - Took asterisk out.
                                    <label className="col-form-label text-uppercase" htmlFor="name">*<span className="red">*</span>Sub Genre:</label>
                                    */}
								<label className="col-form-label text-uppercase" htmlFor="name">
									<span className="red"></span>Sub Genre:
								</label>
							</p>
						</div>
						<div className="col-md-6 col-lg-4 col-10">
							<select
								value={
									state.stepdata.sub_genre_id
										? state.stepdata.sub_genre_id
										: "notSelected"
								}
								className="form-control"
								name="sub_genre_id"
								onChange={handleInputChange}
							>
								{/* Lalo: -02/23/2021 Change 'Select One' to 'none' Also allow to be chosen, take 'disabled' out*/}
								<option value="notSelected">none</option>
								{state.subGenre.map((subGenre, index) => (
									<>
										{state.stepdata.genre_id == subGenre.genre_id && (
											<option key={index} value={subGenre.sub_genre_id}>
												{subGenre.name}
											</option>
										)}
									</>
								))}
							</select>
							{state.error.sub_genre_id && (
								<span id="error" className="error-text">
									{state.error.sub_genre_id}{" "}
								</span>
							)}
						</div>
						<div className="col-md-2 col-2 lpadding mobileTooltip">
							<Tooltip message={tooltipData[3]} color="#a9adac" />
						</div>

						{/* Lalo: 02/15/2021 Placement for an "unSelect to clear out the chosen subGenre" 
                            <div>
                                <button className="btn btn-danger" value="Unselect" onclick="unSelectSubGenre()">Unselect</button>
                            </div>
                            */}
					</div>
					<div className="form-group row align-items-center step-2">
						<div className="col-sm-4">
							<p className="text-right mobile-text-left">
								<label className="col-form-label text-uppercase" htmlFor="name">
									<span className="red">*</span>Copyright Year:
								</label>
							</p>
						</div>
						{/* <label className="col-sm-4 col-form-label text-right text-uppercase" htmlFor="name"><span className="red">*</span>Copyright Year:</label> */}
						<div className="col-md-6 col-lg-4 col-10">
							<input
								type="text"
								onBlur={() => {
									errorValidation("copyright_year");
								}}
								value={
									state.stepdata.copyright_year
										? state.stepdata.copyright_year
										: ""
								}
								onChange={handleInputChange}
								name="copyright_year"
								className="form-control"
								id=""
								placeholder=""
							/>
							{state.error.copyright_year && (
								<span id="error" className="error-text">
									{state.error.copyright_year}{" "}
								</span>
							)}
						</div>
						<div className="col-md-2 col-2 lpadding mobileTooltip">
							<Tooltip message={tooltipData[4]} color="#a9adac" />
						</div>
					</div>
					<div className="form-group row">
						<label
							className="col-sm-4 col-form-label text-right mobile-text-left text-uppercase"
							htmlFor="name"
						>
							Copyright #:
						</label>
						<div className="col-md-6 col-lg-4 col-10">
							<input
								type="text"
								value={
									state.stepdata.copyright_number
										? state.stepdata.copyright_number
										: ""
								}
								onChange={handleInputChange}
								name="copyright_number"
								className="form-control"
								id=""
								placeholder=""
							/>
						</div>
						<div className="col-md-2 col-2 lpadding mobileTooltip">
							<Tooltip message={tooltipData[5]} color="#a9adac" />
						</div>
					</div>
					<div className="form-group row">
						<label
							className="col-sm-4 col-form-label text-right mobile-text-left text-uppercase"
							htmlFor="name"
						>
							Copyright Owner:
						</label>
						<div className="col-md-6 col-lg-4 col-10">
							<input
								type="text"
								value={
									state.stepdata.copyright_owner
										? state.stepdata.copyright_owner
										: ""
								}
								onChange={handleInputChange}
								name="copyright_owner"
								className="form-control"
								id=""
								placeholder=""
							/>
						</div>
						<div className="col-md-2 col-2 lpadding mobileTooltip">
							<Tooltip message={tooltipData[6]} color="#a9adac" />
						</div>
					</div>
					{/* Lalo: 03/01/2021 - Per request the UPC Barcode was taken out...thought I had done it, but it was still there.
                        <div className="form-group row">
                            <label className="col-sm-4 col-form-label text-right mobile-text-left text-uppercase" htmlFor="name">UPC Barcode #:</label>
                            <div className="col-md-6 col-lg-4 col-10"> <input type="text" value={state.stepdata.upc_barcode ? state.stepdata.upc_barcode : ''} onChange={handleInputChange} name="upc_barcode" className="form-control" id="" placeholder="" /></div>
                            <div className="col-md-2 col-2 lpadding mobileTooltip">
                                <Tooltip message={tooltipData[6]} color="#a9adac" />
                            </div>
                        </div>
*/}
					<div className="form-group row align-items-center">
						<label
							className="col-sm-4 col-form-label text-right text-uppercase"
							htmlFor="name"
						>
							<span className="red">*</span>does this Dalbum contain explicit
							material?
						</label>
						<div className="col-md-8 lpadding">
							{[
								{ name: "yes", value: 1 },
								{ name: "no", value: 0 },
							].map((elem, index) => (
								<div
									key={index}
									className="d-inline form-check form-group text-center"
								>
									<input
										type="radio"
										className="form-check-input"
										id={elem.name}
										name="soloOrBand"
										checked={
											state.stepdata.contain_explicit_material == elem.value
												? true
												: false
										}
										value={elem.value}
										onChange={(e) => containExplicit(e)}
									/>

									<label className="form-check-label" htmlFor={elem.name}>
										{elem.name}
									</label>
								</div>
							))}
							{state.error.contain_explicit_material && (
								<span id="error" className="error-text">
									{state.error.contain_explicit_material}{" "}
								</span>
							)}
							{/* Lalo: 02/23/2021 - Chamged tooltip attay reference from 7 to 6 to put back the corresponding tooltip text. */}
							<span className="largeTooltip">
								<Tooltip
									claz="bigtooltiptext largeTextScroll"
									message={tooltipData[7]}
									color="#a9adac"
								/>
							</span>
						</div>
					</div>
					<div className="row form-group justify-content-center">
						<button
							type="button"
							className="btn-cancel text-uppercase"
							onClick={() => {
								back();
							}}
						>
							Back
						</button>
						<button
							type="button"
							className="btn-save text-uppercase"
							onClick={() => {
								next();
							}}
						>
							Next
						</button>
					</div>
				</div>
			</div>
		</div>
	);
});

export default Step2AddAlbumComponent;
